<template>
  <div>
    <b-row v-if="checkAccessPrivilege('Promotion.Referral.Search')">
      <b-col sm="12" md="12">
        <b-card no-body>
          <b-card-header>
              <h5 class="float-left"><i class='fa fa-search'></i> Search</h5>
          </b-card-header>
          <b-card-body>
            <b-form>
              <b-row>
                <b-col sm="3">
                  <label class="mr-sm-2" for="sTicket">Ticket Number </label>
                  <b-input id="sTicket" type="text" placeholder="" v-model.trim="sTicket"></b-input>
                </b-col>
                <b-col sm="3">
                  <label class="mr-sm-2" for="sUsername">Username </label>
                  <b-input id="sUsername" type="text" placeholder="" v-model.trim="sUsername"></b-input>
                </b-col>
                <b-col sm="3">
                  <label class="mr-sm-2" for="sType">Bonus Player Type </label>
                  <b-form-select id="sType" :plain="true" :options="typeOption" v-model="sType" text-field="Name" value-field="Id">
                    <template slot="first">
                      <option :value="null">-- Please select an option --</option>
                    </template>
                  </b-form-select>
                </b-col>
              </b-row>
              <br>
              <b-row>
                <b-col sm="3">
                  <label class="mr-sm-2" for="sStatus">Status </label>
                  <b-form-select id="sStatus" :plain="true" :options="statusOption" v-model="sStatus" text-field="Name" value-field="Id">
                    <template slot="first">
                      <option :value="null">-- Please select an option --</option>
                    </template>
                  </b-form-select>
                </b-col>
                <b-col sm="3">
                  <label class="mr-sm-2" for="sStartTime">From (yyyy/mm/dd 00:00:00)</label>
                  <b-input id="sStartTime" type="date" placeholder="" v-model.trim="sStartTime"></b-input>
                </b-col>
                <b-col sm="3">
                  <label class="mr-sm-2" for="sEndTime">To (yyyy/mm/dd 23:59:59)</label>
                  <b-input id="sEndTime" type="date" placeholder="" v-model.trim="sEndTime"></b-input>
                </b-col>
                <b-col sm="4" class="align-self-end">
                  <b-button id="sBtn" variant="primary" @click="getTicket"><i class="fa fa-search"></i> Search</b-button>
                </b-col>
              </b-row>
            </b-form>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12" md="12">
        <b-card no-body>
          <b-card-header>
              <h3 class="float-left"><i class='fa fa-users'></i> Referral Bonus Player List</h3>
          </b-card-header>
          <b-card-body>
            <div class="overflow-auto">
              <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="items" :fields="fields">
                <template v-slot:cell(sn)="data">
                  {{data.index+1 + ((currentPage-1)*perPage)}}
                </template>
                <template v-slot:cell(Status)="data">
                  <b-badge variant="warning" v-if="data.item.Status === 0">Created</b-badge>
                  <b-badge variant="info" v-if="data.item.Status === 1">Processing</b-badge>
                  <b-badge variant="success" v-if="data.item.Status === 2">Success</b-badge>
                  <b-badge variant="danger" v-if="data.item.Status === 3">Failed</b-badge>
                  <b-badge variant="success" v-if="data.item.Status === 4">Manual Handle</b-badge>
                </template>
                <template v-slot:cell(Type)="data">
                  <b-badge variant="success" v-if="data.item.Type === 1">Referee</b-badge>
                  <b-badge variant="success" v-if="data.item.Type === 2">Referrer</b-badge>
                </template>
                <template v-slot:cell(RefId)="data">
                  <span v-if="data.item.Type === 1">Referred By<br/>{{ data.item.RefId }}</span>
                  <span v-if="data.item.Type === 2">Referred To<br/>{{ data.item.RefId }}</span>
                </template>
                <template v-slot:cell(Action)="data">
                  <b-button variant="danger" v-if="[0, 1, 3].includes(data.item.Status) && checkAccessPrivilege('Promotion.Referral.Redeem')" @click="confirm(data.item.Id)">Redeem</b-button>
                </template>
              </b-table>
              <nav>
                <b-pagination :total-rows="getRowCount(items)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
              </nav>
            </div>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-modal ref="confirm" size="lg" centered header-bg-variant="primary" hide-footer title="Redeem This Ticket">
      <div class="mb-3">
        Are you sure?
      </div>
      <b-button variant="success" @click="redeemTicket">Yes</b-button>
      <b-button variant="outline-danger" @click="cancelRedeem">Cancel</b-button>
    </b-modal>
  </div>
</template>

<script>
  import VueNotifications from 'vue-notifications'
  import {Events} from '../../../events.js'
  // import moment from 'moment-timezone'

  export default {
    name: 'referral-member-list',
    props: {
      caption: {
        type: String,
        default: 'Table'
      },
      hover: {
        type: Boolean,
        default: false
      },
      striped: {
        type: Boolean,
        default: false
      },
      bordered: {
        type: Boolean,
        default: false
      },
      small: {
        type: Boolean,
        default: false
      },
      fixed: {
        type: Boolean,
        default: false
      }
    },
    data: () => {
      return {
        items: [],
        statusOption: [
          { Id: '0', Name: 'Created' },
          { Id: '1', Name: 'Processing' },
          { Id: '2', Name: 'Success' },
          { Id: '3', Name: 'Failed' },
          { Id: '4', Name: 'Manual Handle' }
        ],
        typeOption: [
          { Id: 1, Name: 'Referee (Referred To / Upline Player)' },
          { Id: 2, Name: 'Referrer (Referred By / Downline Player)' }
        ],
        fields: [
          {key: 'sn', label: 'S.No'},
          {key: 'Ticket', label: 'Ticket Number'},
          {key: 'Username', label: 'Username'},
          {key: 'Amount', label: 'Bonus Amount'},
          {key: 'Type', label: 'Type'},
          {key: 'RefId', label: 'Reference Id'},
          {key: 'Status', label: 'Status'},
          {key: 'Operator', label: 'Operator'},
          {key: 'AddTime', label: 'AddTime'},
          {key: 'Action', label: 'Action'}
        ],
        currentPage: 1,
        rowCount: 0,
        perPage: 50,
        operator: '',
        sTicket: '',
        sUsername: '',
        sType: null,
        sStatus: null,
        sStartTime: '',
        sEndTime: '',
        showUpdateModal: false,
        updateData: {},
        redeemId: ''
      }
    },
    watch: {
      currentPage: function () {
        this.getTicket()
      }
    },
    methods: {
      getRowCount () {
        return this.rowCount
      },
      getTicket () {
        let ticket = this.sTicket
        let username = this.sUsername
        let type = this.sType || ''
        let status = this.sStatus || ''
        let startTime = this.sStartTime
        let endTime = this.sEndTime
        let page = this.currentPage
        let size = this.perPage
        Events.$emit('loader')

        let queryStr = `?page=${page}&size=${size}&ticket=${ticket}&username=${username}&type=${type}&status=${status}&startTime=${startTime}&endTime=${endTime}`
        this.$http.get(this.API_ENDPOINT + '/promotion/referral/list' + queryStr, {headers: { 'Content-Type': 'application/json' }}).then(response => {
          this.items = response.data.data
          this.rowCount = response.data.rowCount
          Events.$emit('loader')
        }).catch(err => {
          Events.$emit('loader')
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        })
      },
      async redeemTicket () {
        try {
          let response = await this.$http.post(this.API_ENDPOINT + '/promotion/referral/mark', { id: this.redeemId }, { headers: { 'Content-Type': 'application/json' } })
          if (response.status === 200) {
            this.getTicket()
            this.cancelRedeem()
            Events.$emit('alert', VueNotifications.types.success, 'Success', 'Ticket Redeemed.')
          }
        } catch (err) {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        }
      },
      confirm (id) {
        this.redeemId = id
        this.$refs.confirm.show()
      },
      cancelRedeem () {
        this.redeemId = ''
        this.$refs.confirm.hide()
      },
      checkAccessPrivilege (module) {
        if (!module) return true
        return this.PRIVILEGE.includes(module)
      }
    },
    created () {
      let user = JSON.parse(window.sessionStorage.getItem('user'))
      this.operator = user.username
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/promotion/referral/ReferralTable.vue